// export const Configurator:any[]  = [
//   {
//     "title": "Set-up your store",
//     "description": "Use this guide to get your store up and running.",
//     "completedTasks": 0,
//     "totalTasks": 4,
//     "collapsed": true,
// "completionText":"Complete"
// ,    
// "tasks": [
//       {
//         "title": "Set-up your base location",
//         "description": "Currently, your temporary base location name is set to default. Base location will be displayed on receipts and for tax calculations.",
//         "buttonText": "Set-up location",
//         "link": "https://developer.pax.us/"
//       },
//       {
//         "title": "Add Products",
//         "description": "Currently, your temporary base location name is set to default. Base location will be displayed on receipts and for tax calculations.",
//         "buttonText": "Set-up location",
//         "link": "https://developer.pax.us/"
//       },
//       {
//         "title": "Review your shipping settings",
//         "completed": true,
//         "description": "Currently, your temporary base location name is set to default. Base location will be displayed on receipts and for tax calculations.",
//         "buttonText": "Set-up location",
//         "link": "https://developer.pax.us/"
//       },
//       {
//         "title": "Review your tax settings"
//       },
//       {
//         "title": "Set up Payment Providers"
//       }
//     ]
//   },
//   {
//     "title": "Set-up your Online Store",
//     "description": "Use this guide to get your store up and running.",
//     "completedTasks": 0,
//     "totalTasks": 6,
//     "collapsed": true,
// "completionText":"Complete"
// ,    
// "tasks": [
//       {
//         "title": "Add Products",
//         "description": "Currently, your temporary base location name is set to default. Base location will be displayed on receipts and for tax calculations.",
//         "buttonText": "Set-up location",
//         "link": "https://developer.pax.us/",
//         "completed": true
//       },
//       {
//         "title": "Add Contact info for website",
//         "completed": true
//       },
//       {
//         "title": "Select your shipping methods",
//         "completed": true
//       },
//       {
//         "title": "Review your tax settings",
//          "completed": true
//       },
//       {
//         "title": "Set up Payment Providers",
//          "completed": true
//       }
//     ]
//   }
//]

export const Configurator:any[]=[
  //{
    // "stepID": "S001",
    // "title": "Business Set-up",
    // "description": "Complete all steps to set-up your business and start selling.",
    // "completion": 25,
    // "completedTasks": 0,
    // "totalTasks": 2,
    // "collapsed": true,
    // "isRequired": true,
    // "isCompleted": true,
    // "completionText":"Complete"
    // ,
    // "tasks": [
    //   {
    //     "taskID": "T001",
    //     "title": "Set-up your base location",
    //     "description": "Currently, your temporary base location name is set to default. Base location will be displayed on receipts and for tax calculations.",
    //     "helpText": null,
    //     "helpLink": null,
    //     "actionType":"InternalLink",
    //     "actionLink": "app/locations-list",
    //     "actionText": "Set-up Base Location",
    //     "isRequired": true,
    //     "isCompleted": true,
    //     "prequisiteIDs":[]
    //   },
    //   {
    //     "taskID": "T002",
    //     "title": "Add Products",
    //     "description": "Import your product list with oneclick or write descriptions, add images, and set prices of your products manually.",
    //     "helpText": null,
    //     "helpLink": null,
    //     "actionType":"InternalLink",
    //     "actionLink": "app/products",
    //     "actionText": "Add your first product",
    //     "isRequired": true,
    //     "isCompleted": false,
    //     "prequisiteIDs":[]
    //   },
      // {
      //   "taskID": "T004",
      //   "title": "Review your tax settings",
      //   "description": "Configure tax rate according to your area. Currently it is set to 8.25%",
      //   "helpText": null,
      //   "helpLink": null,
      //   "actionType":"InternalLink",
      //   "actionLink": "app/business/tax",
      //   "actionText": "Review Tax Configuration",
      //   "isRequired": false,
      //   "isCompleted": false,
      //   "prequisiteIDs":[]
      // },
      // {
      //   "taskID": "T0012",
      //   "title": "Set-up Loyalty Program",
      //   "description": "Enable it if you want to run loyalty program for your business",
      //   "helpText": null,
      //   "helpLink": null,
      //   "actionType":"InternalLink",
      //   "actionLink": "app/business/tax",
      //   "actionText": "Open Tax Configuration",
      //   "isRequired": false,
      //   "isCompleted": false
      // }
  //   ]
  // },
  {
    "stepID": "S002",
    "title": "Store Set-up",
    "description": "complete these steps to setup your business",
    "completion": 0,
    "completedTasks": 0,
    "totalTasks": 4,
    "collapsed": true,
    "isRequired": true,
    "isCompleted": false,
    "prequisiteIDs": [{ "stepID": "S001" }],
    "completionText":"Complete"
    ,
    "tasks": [
      
      {
        "taskID": "T005",
        "title": "Select Online Store Template",
        "description": "Select from predefined templates matching your business.",
        "helpText": null,
        "helpLink": null,
        "actionType":"InternalLink",
        "actionLink": "select-template",
        "actionText": "Select Online Store Template",
        "isRequired": false,
        "isCompleted": false,
        "prequisiteIDs":[]
      },
      {
        "taskID": "T002",
        "title": "Add Products",
        "description": "Import your product list with oneclick or write descriptions, add images, and set prices of your products manually.",
        "helpText": null,
        "helpLink": null,
        "actionType":"InternalLink",
        "actionLink": "app/products",
        "actionText": "Add your first product",
        "isRequired": false,
        "isCompleted": false,
        "prequisiteIDs":[]
      },
      {
        "taskID": "T007",
        "title": "Set-up Shipping for Online Store",
        "description": "Select which shipping options are available to customers when checking out. Add flat delivery, self pickup, or UPS integration.",
        "helpText": null,
        "helpLink": null,
        "actionType":"InternalLink",
        "actionLink": "app/business/shipping",
        "actionText": "Shipping Configuration",
        "isRequired": false,
        "isCompleted": false,
        "prequisiteIDs":[],
        "isEditable":true
      },
      {
        "taskID": "T008",
        "title": "Set-up Payments",
        "description": "Connect Stripe account for Online Store Payment processing.",
        "helpText": null,
        "helpLink": null,
        "actionType":"InternalLink",
        "actionLink": "app/business/payment-processing",
        "actionText": "Set-up Payments",
        "isRequired": true,
        "isCompleted": false,
        "prequisiteIDs": [{ "taskID": "T007" }]
      },
      // {
      //   "taskID": "T006",
      //   "title": "Add content to your online store",
      //   "description": "Build your online storefront with LincSell's free website builder. Customize, edit, and start selling with ease.",
      //   "helpText": null,
      //   "helpLink": null,
      //   "actionType":"InternalLink",
      //   "actionLink": "select-template",
      //   "actionText": "Online Store Editor",
      //   "isRequired": false,
      //   "isCompleted": false,
      //   "prequisiteIDs":[]
      // },
      // {
      //   "taskID": "T009",
      //   "title": "Go Live",
      //   "description": "Review go live checklist and go live to start selling online.",
      //   "helpText": null,
      //   "helpLink": null,
      //   "actionType":"InternalLink",
      //   "actionLink": "app/onelinestoregolive",
      //   "actionText": "Go Live",
      //   "isRequired": true,
      //   "isCompleted": false,
      //   "prequisiteIDs": [{ "taskID": "T007" },{ "taskID": "T001" },{ "taskID": "T002" },{ "taskID": "T008" }]
      // }
    ]
  },
  // {
  //   "stepID": "S003",
  //   "title": "Point of Sale Set-up",
  //   "description": "Configure Point of Sale for In-Person Sales and payments.",
  //   "completion": 0,
  //   "completedTasks": 0,
  //   "totalTasks": 4,
  //   "collapsed": true,
  //   "isRequired": true,
  //   "isCompleted": false,
  //   "prequisiteIDs": [{ "stepID": "S001" }],
  //   "completionText":"Complete"
  //   ,
  //   "tasks": [
  //     {
  //       "taskID": "T002",
  //       "title": "Add Products",
  //       "description": "Import your product list with oneclick or write descriptions, add images, and set prices of your products manually.",
  //       "helpText": null,
  //       "helpLink": null,
  //       "actionType":"InternalLink",
  //       "actionLink": "app/products",
  //       "actionText": "Add your first product",
  //       "isRequired": false,
  //       "isCompleted": false,
  //       "prequisiteIDs":[]
  //     },
      
  //     {
  //       "taskID": "T011",
  //       "title": "Get Point of Sale App",
  //       "description": "Install Point of Sale by getting link in email. You can download using QR code. Complete the Setup in App to complete this step",
  //       "helpText": null,
  //       "helpLink": null,
  //       "actionType":"ShowPOSLinks",
  //       "actionLink": "ShowPOSLinks",
  //       "actionText": "Show download options",
  //       "isRequired": true,
  //       "isCompleted": false,
  //       "prequisiteIDs": [{ "taskID": "T007" }]
  //     },
  //       {
  //       "taskID": "T012",
  //       "title": "Create your first sale",
  //       "description": "Perform a test transaction on Point of Sale",
  //       "helpText": null,
  //       "helpLink": null,
  //       "actionType":"ShowPOSLinks",
  //       "actionLink": "ShowPOSLinks",
  //       "actionText": "Download POS",
  //       "isRequired": true,
  //       "isCompleted": false,
  //       "prequisiteIDs": [{ "taskID": "T011" }]
  //     },
  //     {
  //       "taskID": "T010",
  //       "title": "Set-up In-Store Payments",
  //       "description": "View list of documentation and steps required to collect In-Person Payments.",
  //       "helpText": null,
  //       "helpLink": null,
  //       "actionType":"InternalLink",
  //       "actionLink": "app/business/payment-processing",
  //       "actionText": "View Guide",
  //       "isRequired": true,
  //       "isCompleted": false,
  //       "prequisiteIDs": [{ "taskID": "T007" }]
  //     }
  //   ]
  // },
  // {
  //   "stepID": "S004",
  //   "title": "Customer App Set-up",
  //   "description": "Connect with your customer through online customer App.",
  //   "completion": 0,
  //   "completedTasks": 0,
  //   "totalTasks": 2,
  //   "collapsed": true,
  //   "isRequired": true,
  //   "isCompleted": false,
  //   "prequisiteIDs": [],
  //   "completionText":"Disabled"
  //   ,
  //   "tasks": [
  //     {
  //       "taskID": "T4001",
  //       "title": "Download Demo App",
  //       "description": "A demo app to let you review the functionality",
  //       "helpText": null,
  //       "helpLink": null,
  //       "actionType":"customerappdemo",
  //       "actionLink": "customerappdemo",
  //       "actionText": "Download App",
  //       "isRequired": false,
  //       "isCompleted": false,
  //       "prequisiteIDs":[]
  //     },
  //      {
  //       "taskID": "T4002",
  //       "title": "Enable Customer App",
  //       "description": "Talk to support for Customer App Activation",
  //       "helpText": null,
  //       "helpLink": null,
  //       "actionType":"supportinfopopup",
  //       "actionLink": "supportinfopopup",
  //       "actionText": "Contact Support",
  //       "isRequired": false,
  //       "isCompleted": false,
  //       "prequisiteIDs":[]
  //     },
      
  //   ]
  // }
]


